<template>
  <v-navigation-drawer expand-on-hover rail>
    <v-hover v-slot="{ isHovering, props }" open-delay="50">
      <v-list class="nav-list-item" v-bind="props" :color="isHovering ? 'surface-light' : undefined"
        :elevation="isHovering ? 6 : 1" @click="goProjectView">
        <v-img alt="QWEB Logo" contain :src="require(`@/assets/LogoNoBgOffsite.png`)" width="60" height="40" />
        <h4 v-if="store.getters.userAgent === 'desktop'" class="nav-title" style="margin-right: 50px;">Offsite Wood</h4>
      </v-list>
    </v-hover>

    <v-divider opacity="0.75" thickness="2" color="gray"></v-divider>

    <v-list v-if="isAuthenticated && isManufacturer" density="compact" nav>
      <v-hover
        v-for="area in manufacturerMenuItems"
        :key="area.id"
        v-slot="{ isHovering, props }"
        open-delay="50"
      >
        <v-list-item
          v-bind="props"
          :title="$t(area.titleKey)"
          :value="area.id"
          :disabled="area.disabled"
          :elevation="isHovering && !area.disabled ? 4 : 1"
          @click="handleManufacturerNav(area)"
          @keydown.enter.prevent="handleManufacturerNav(area)"
          @keydown.space.prevent="handleManufacturerNav(area)"
        >
          <template v-slot:prepend>
            <v-icon size="26" class="mr-3">
              {{ area.icon }}
            </v-icon>
          </template>
          <template v-slot:append>
            <v-chip
              size="x-small"
              variant="tonal"
              :color="manufacturerStatusColor(area.statusKey)"
            >
              {{ $t(area.statusKey) }}
            </v-chip>
          </template>
        </v-list-item>
      </v-hover>
    </v-list>

    <v-list v-else-if="isAuthenticated && isAdminPortal" density="compact" nav>
      <v-hover v-slot="{ isHovering, props }" open-delay="50">
        <v-list-item
          v-bind="props"
          :title="$t('views.admin.portal.navigation.userManagement')"
          value="adminPortal"
          :elevation="isHovering ? 4 : 1"
          @click="goToAdminPortal"
          @keydown.enter.prevent="goToAdminPortal"
          @keydown.space.prevent="goToAdminPortal"
        >
          <template v-slot:prepend>
            <v-icon size="26" class="mr-3">mdi-account-multiple</v-icon>
          </template>
        </v-list-item>
      </v-hover>
    </v-list>

    <v-list v-else-if="isAuthenticated && isStructure && projectSelected" density="compact" nav>
      <v-hover
        v-for="area in structureMenuItems"
        :key="area.id"
        v-slot="{ isHovering, props }"
        open-delay="50"
      >
        <v-list-item
          v-bind="props"
          :title="$t(area.titleKey)"
          :value="area.id"
          :disabled="area.disabled"
          :elevation="isHovering && !area.disabled ? 4 : 1"
          @click="handleStructureNav(area)"
          @keydown.enter.prevent="handleStructureNav(area)"
          @keydown.space.prevent="handleStructureNav(area)"
        >
          <template v-slot:prepend>
            <v-icon size="26" class="mr-3">{{ area.icon }}</v-icon>
          </template>
        </v-list-item>
      </v-hover>
    </v-list>

    <v-list v-else-if="isAuthenticated && isCarbonManager" density="compact" nav>
      <v-hover v-slot="{ isHovering, props }" open-delay="50">
        <v-list-item
          v-bind="props"
          title="Matériels"
          value="carbonManagerMaterials"
          :elevation="isHovering ? 4 : 1"
          @click="goToCarbonManagerPortal"
          @keydown.enter.prevent="goToCarbonManagerPortal"
          @keydown.space.prevent="goToCarbonManagerPortal"
        >
          <template v-slot:prepend>
            <v-icon size="26" class="mr-3">mdi-table</v-icon>
          </template>
        </v-list-item>
      </v-hover>
    </v-list>

    <v-list v-else-if="isAuthenticated && projectSelected" density="compact" nav>
      <template v-for="item in architectMenuItems" :key="item.id">
        <v-divider v-if="item.type === 'spacer'" class="my-5" opacity="0.75" thickness="3" color="gray"/>

        <v-hover v-else v-slot="{ isHovering, props }" open-delay="50">
          <v-list-item
            v-bind="props"
            :title="item.titleKey ? $t(item.titleKey) : ''"
            :value="item.id"
            :elevation="isHovering ? 4 : 1"
            @click="architectAction(item)"
            @keydown.enter.prevent="architectAction(item)"
            @keydown.space.prevent="architectAction(item)"
          >
            <template v-slot:prepend>
              <v-img
                v-if="item.iconSrc"
                :alt="item.titleKey ? $t(item.titleKey) : ''"
                contain
                :src="item.iconSrc"
                width="26"
                height="26"
                style="margin-right: 12px;"
              />
            </template>
          </v-list-item>
        </v-hover>
      </template>
    </v-list>

  <v-list v-else-if="isAuthenticated" density="compact" nav>
      
      <v-hover v-slot="{ isHovering, props }" open-delay="50">
        <v-list-item :title="$t('functionalities.projectsListing.name')" value="projectView" v-bind="props"
          :color="isHovering ? 'surface-light' : undefined" :elevation="isHovering ? 4 : 1"
          @click="goHome">
          <template v-slot:prepend>
            <v-img :alt="$t('functionalities.projectsListing.name')" contain :src="require(`@/assets/IconHome.png`)"
              width="26" height="26" style="margin-right: 12px;" />
          </template>
        </v-list-item>
      </v-hover>

    </v-list>

    <template v-if="isAuthenticated && !isManufacturer && !isAdminPortal && !isCarbonManager" #append>
      <v-divider opacity="0.75" thickness="1" color="gray" />
      <v-list density="compact" nav>
        <v-hover v-slot="{ isHovering, props }" open-delay="50">
          <v-list-item
            v-bind="props"
            :title="$t('views.architect.navigation.settings')"
            value="settings"
            :elevation="isHovering ? 4 : 1"
            @click="goToSettings"
            @keydown.enter.prevent="goToSettings"
            @keydown.space.prevent="goToSettings"
          >
            <template v-slot:prepend>
              <v-icon size="26" class="mr-3">mdi-cog-outline</v-icon>
            </template>
          </v-list-item>
        </v-hover>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from 'vue-router'
import { manufacturerAreas } from '@/constants/manufacturerAreas';
import { architectNavigationItems } from '@/constants/architectAreas';
import { structureAreas } from '@/constants/structureAreas';

const router = useRouter()
const store = useStore();

const manufacturerMenuItems = computed(() => manufacturerAreas);
const structureMenuItems = computed(() => structureAreas);
const normalizedRole = computed(() => store.state.user?.role?.toLowerCase().replace(/\s+/g, '') ?? '');
const isManufacturer = computed(() => normalizedRole.value === 'manufacturer');
const isAdminPortal = computed(() => normalizedRole.value === 'admin');
const isStructure = computed(() => normalizedRole.value === 'structure');
const isCarbonManager = computed(() => normalizedRole.value === 'carbonmanager');

function goHome() {
  if (!isAuthenticated.value) {
    router.push({ name: 'HomeView' });
    return;
  }

  if (isManufacturer.value) {
    router.push({ name: 'ManufacturerDashboard' });
    return;
  }

  const projectRouteName = normalizedRole.value === 'structure' ? 'StructureProject' : 'ArchitectProject';
  router.push({ name: projectRouteName });
}
function goProjectView() {
  if (!isAuthenticated.value) {
    router.push({ name: 'HomeView' });
    return;
  }

  if (isManufacturer.value) {
    router.push({ name: 'ManufacturerDashboard' });
    return;
  }

  if(projectSelected.value){
    const dashboardRouteName = normalizedRole.value === 'structure' ? 'StructureDashboard' : 'ArchitectDashboard';
    router.push({ name: dashboardRouteName })
  } else {
    const projectRouteName = normalizedRole.value === 'structure' ? 'StructureProject' : 'ArchitectProject';
    router.push({ name: projectRouteName });
  }
}
function goToProjectInformationView() {
  router.push({ name: 'ProjectInformationView' })
}
function goToPanelCountEstimatorView() {
  router.push({ name: 'PanelCountEstimatorView' })
}
function goToCarbonImpactEstimatorView() {
  router.push({ name: 'CarbonImpactEstimatorView' })
}
function goToBudgetaryCostToolView() {
  router.push({ name: 'BudgetaryCostToolView' })
}
function goToExpertInputBuilderLogisticsView() {
  router.push({ name: 'ExpertInputBuilderLogisticsView' })
}

function goToAdminPortal() {
  router.push({ name: 'AdminPortal' })
}

function goToCarbonManagerPortal() {
  router.push({ name: 'CarbonManagerPortal' })
}

function handleStructureNav(area) {
  if (area.disabled || !area.to) {
    return;
  }
  router.push(area.to);
}

function handleManufacturerNav(area) {
  if (area.disabled || !area.to) {
    return;
  }
  router.push(area.to);
}

const architectActionMap = {
  home: () => router.push({ name: 'ArchitectProject' }),
  projectInformation: goToProjectInformationView,
  dashboard: () => router.push({ name: 'ArchitectDashboard' }),
  panelCountEstimator: goToPanelCountEstimatorView,
  carbonImpactEstimator: goToCarbonImpactEstimatorView,
  expertInputBuilderLogistics: goToExpertInputBuilderLogisticsView,
  budgetaryCostTool: goToBudgetaryCostToolView,
  comments: () => router.push({ name: 'CommentsView' }),
  manageColaborators: () => router.push({ name: 'ManageCollaboratorsView' })
};

function goToSettings() {
  router.push({ name: 'ArchitectSettingsView' });
}

function architectAction(item) {
  if (!item || item.type === 'spacer') {
    return;
  }

  if (item.to) {
    router.push(item.to);
    return;
  }

  const action = architectActionMap[item.id];
  if (typeof action === 'function') {
    action();
  }
}

function manufacturerStatusColor(statusKey) {
  switch (statusKey) {
    case 'views.manufacturer.dashboard.status.available':
      return 'success';
    case 'views.manufacturer.dashboard.status.notConfigured':
      return 'warning';
    default:
      return 'secondary';
  }
}

// Computed properties
const isAuthenticated = computed(() => {
  return store.getters.isAuthenticated
})

const projectSelected = computed(() => {
  return store.state.projectData?.projectId != null && store.state.currentModel != null;
});

const architectMenuItems = computed(() => {
  if (!projectSelected.value) {
    return [];
  }

  return architectNavigationItems;
});

</script>

<style scoped>
@import '@/assets/styles/components/NavDrawer.css';
</style>